// Avalia se uma pergunta condicional deve aparecer, dado o estado das respostas.
// p.DependeDeCodigo = código da pergunta controladora; p.DependeDeValor = valor que exibe.
export function perguntaVisivel(p, respostas, byCodigo) {
  if (!p.DependeDeCodigo) return true;
  const ctrl = byCodigo[p.DependeDeCodigo];
  if (!ctrl) return true;
  const ans = respostas[ctrl.Id];
  if (ctrl.TipoResposta === "bool") return String(!!ans) === String(p.DependeDeValor);
  if (ctrl.TipoResposta === "selecao" || ctrl.TipoResposta === "multipla") {
    const op = (ctrl.Opcoes || []).find((o) => String(o.Id) === String(ans));
    return op ? String(op.Valor) === String(p.DependeDeValor) : false;
  }
  return String(ans ?? "") === String(p.DependeDeValor);
}

// Agrupa perguntas por Seção preservando a ordem de aparição das seções.
export function agruparPorSecao(perguntas) {
  const map = new Map();
  perguntas.forEach((p) => {
    const s = p.Secao || "Geral";
    if (!map.has(s)) map.set(s, []);
    map.get(s).push(p);
  });
  return Array.from(map.entries());
}

// Mapa código -> pergunta (para resolver dependências).
export function indexarPorCodigo(perguntas) {
  const o = {};
  perguntas.forEach((p) => { if (p.Codigo) o[p.Codigo] = p; });
  return o;
}

// Uma resposta está preenchida? (checkbox sempre tem estado -> considerado ok)
export function respostaPreenchida(p, respostas) {
  if (p.TipoResposta === "bool") return true;
  const v = respostas[p.Id];
  return v !== undefined && v !== null && String(v).trim() !== "";
}

// Perguntas obrigatórias, visíveis e ainda não respondidas.
export function perguntasPendentes(perguntas, respostas, byCodigo) {
  return perguntas.filter(
    (p) => p.Obrigatoria && perguntaVisivel(p, respostas, byCodigo) && !respostaPreenchida(p, respostas)
  );
}
